import { MemberPlanElement } from '../../account/types';
import { EntryResource, VisitType } from '../Components/select-service-type/types';

export type GetVisitFeeProps = {
  visitType?: VisitType | null;
  visitPlan?: MemberPlanElement | null;
  visitServiceType?: EntryResource | null;
};

export const getVisitFee = (visit: GetVisitFeeProps) => {
  const visitFee = parseFloat(visit?.visitType ? visit?.visitType.visitFee : '0');
  const discount = getVisitDiscount(visit);
  return visitFee - (visitFee * discount) / 100;
};

const getVisitDiscount = (visit: GetVisitFeeProps) => {
  // discount if selected service is included on selected plan
  const discount =
    visit.visitPlan &&
    visit.visitServiceType &&
    visit.visitPlan?.serviceType?.find(
      (planServiceType) => planServiceType?.reference?.reference === visit?.visitServiceType?.id,
    )
      ? visit.visitPlan?.visitDiscount
      : 0;

  return discount;
};
